import { useTranslation } from 'react-i18next';
import { XIcon } from '@/shared/ui/icons';
import { IconButton } from '@/shared/ui/buttons/IconButton';
import type { ApiTrackedItem } from '@/shared/types/api/tracking';
import { TrackStateChip } from './TrackStateChip';

type SavedRowProps = {
  item: ApiTrackedItem;
  busy: boolean;
  onRemove: (trekId: string) => void;
};

export const SavedRow = ({ item, busy, onRemove }: SavedRowProps) => {
  const { t } = useTranslation('tracking');
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-ink">{item.trek_id}</p>
        <div className="mt-1">
          <TrackStateChip state={item.state} partyStatus={item.party_status} />
        </div>
      </div>
      <IconButton
        label={t('removeSaved')}
        variant="ghost"
        size="sm"
        disabled={busy}
        onClick={() => onRemove(item.trek_id)}
      >
        <XIcon className="h-5 w-5" />
      </IconButton>
    </div>
  );
};
